import { FC } from "react";
import { ModalAlert } from "assets/svg";

import { Text } from "uikit/Typography";

import { ITextareaContainerProps, ITextareaProps } from "./types";
import { Container, ErrorContainer, TextareaBase, TextareaContainer } from "./styles.new";

const Textarea: FC<ITextareaProps> = (props) => {
  const {
    className,
    alwaysShowErrorBlock = true,
    error,
    label,
    $size,
    $isParentWidth,
    units,
    unitsPosition,
    icon,
    iconPosition,
    errorDataTestId,
    dataTestId,
    optional,
    ...rest
  } = props;

  const textareaContainerProps: ITextareaContainerProps = {
    rows: rest.rows,
    error,
    $size,
    $isParentWidth,
    unitsPosition,
    iconPosition,
    $m: rest.$m,
    $mt: rest.$mt,
    $mb: rest.$mb,
    $ml: rest.$ml,
    $mr: rest.$mr,
  };

  return (
    <Container className={className} data-testid={dataTestId} $isParentWidth={$isParentWidth}>
      {label && (
        <Text $fs="t14" $fw="semiBold">
          {label}
        </Text>
      )}
      <TextareaContainer {...textareaContainerProps}>
        <TextareaBase {...rest} />
      </TextareaContainer>

      {(alwaysShowErrorBlock || error) && (
        <ErrorContainer data-testid={errorDataTestId}>
          {error && <ModalAlert />}
          <Text $fs="t14" $fw="medium" $color="error.500_main">
            {error}
          </Text>
        </ErrorContainer>
      )}
    </Container>
  );
};

export default Textarea;
